import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

export const fetchQuery = async (query) => {
  const response = await axiosWithToken.post(BASE_URL + "dynamic", {query});
  return response.data.length > 0 ? response.data : [];
};

export const fetchByTable = async (tableName,Condition) => {
let tablewithCondition = tableName + Condition;
  const response = await axiosWithToken.get(BASE_URL + tablewithCondition);
  return response.data.list.length > 0 ? response.data.list : [];
};

export const fetchCountOfTable = async (tableName,Condition) => {
let tableWithCondition = Condition ? tableName + Condition : tableName;
  const response = await axiosWithToken.get(BASE_URL + tableWithCondition);
  return response.data? response.data?.[0]?.no_of_rows : {};
};

export const fetchAddresses = async (addressIds, shippingAddressIds = null) => {
  // Handle null or undefined addressIds
  if (!addressIds) {
    return [];
  }
  // Build the combined IDs string, only including shipping if provided
  let allIDS = shippingAddressIds ? `${addressIds},${shippingAddressIds}` : addressIds;  
  // Check if contains non-numeric characters
  const containsNonText = /[a-zA-Z]/.test(allIDS);

  if (containsNonText) {
    return [];
  }
  const parseIds = (ids) => {
    if (!ids) return [];
    return ids.split(",").map(Number).filter(id => id > 0);
  };
  
  const billingAddressArray = parseIds(addressIds);
  const shippingAddressArray = shippingAddressIds ? parseIds(shippingAddressIds) : [];
  
  if (billingAddressArray.length === 0) {
    return [];
  }

  // Combine all unique IDs for the query
  const allIds = [...new Set([...billingAddressArray, ...shippingAddressArray])];
  
  const sqlQuery = {
    query: `SELECT * FROM addresses WHERE id IN (${allIds.join(",")})`,
  };

  try {
    const addressesResponse = await axiosWithToken.post(
      BASE_URL + `dynamic`,
      sqlQuery
    );
    const addresses = addressesResponse.data;

    const result = billingAddressArray.map((id, index) => {
      const address = addresses.find((a) => a.id === id);
      const shippingId = shippingAddressArray[index];
      const shippingInfo = shippingId ? addresses.find((a) => a.id === shippingId) : null;

      return {
        id: address ? address.id : null,
        address: address ? address.address : "",
        shipping: shippingInfo
          ? { id: shippingInfo.id, address: shippingInfo.address }
          : { id: null, address: "" },
      };
    });

    return result;
  } catch (error) {
    console.error("Error fetching addresses:", error);
    return []; 
  }
};


export  function cleanValue(value) {
  if (value === null || value === undefined) return "";
  // Convert numbers to string
  if (typeof value === "number") {
    return value.toString();
  }
  if (typeof value !== "string") {
    return "";
  }
  const trimmed = value.trim();
  if (!trimmed) return "";
  return trimmed.replace(/\t/g, " ");
}

